import { UIOverlayViewStatus } from 'common-ts/dist/models/UIOverlayViewStatus';

import { RootState } from '../store';
import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { sendWebsiteEventMessage } from '../telegrambotevents';
import { socket } from "../socket";

export interface OverlayRepurchaseState {
  streamIsOn: boolean,
  liveStreamDialogState: 'MINI' | 'LIVE',
  miniMuteStatus: 'MUTED' | 'ACTIVE',

  livestreamIntroDialogStatus: UIOverlayViewStatus,

  senderObject: {
    userIdentifier: string
    displayName: string
    customerName: string
  },

  offlineSharescreenState: any
}

// Define the initial state using that type
const initialState: OverlayRepurchaseState = {
  streamIsOn: false,
  liveStreamDialogState: 'MINI',
  miniMuteStatus: 'MUTED',

  livestreamIntroDialogStatus: UIOverlayViewStatus.OffAndReady,

  senderObject: {
    userIdentifier: '',
    displayName: '',
    customerName: ''
  },

  offlineSharescreenState: {},
}

export const sendLivestreamMessage = createAsyncThunk('livestreamState/sendLivestreamMessage', 
async (payload: string, thunkAPI) => {
  const rootState = (thunkAPI.getState() as RootState);

  socket.timeout(3000).emit("chat message", {
    chatUserId: "USER-54101",
    creationDateTime: new Date().toISOString(),
    contentType: "STRING",
    content: "LS17-" + JSON.stringify({
      "Action": "SEND_MESSAGE",
      "Content": payload,
      "Sender": {
        "Attributes": rootState.livestreamState.senderObject,
      }
    }),
    author: "OTHER",
  });

  // thunkAPI.dispatch(setMiniMuteStatus('ACTIVE'));
})

export const sendLivestreamStatus = createAsyncThunk('livestreamState/sendLivestreamStatus', 
async (payload, thunkAPI) => {
  const rootState = (thunkAPI.getState() as RootState);
  const lsDisplayInfo = rootState.livestreamState.streamIsOn ? 
    (rootState.livestreamState.liveStreamDialogState + '-' + rootState.livestreamState.miniMuteStatus) 
    : 'OFF';


  if (!(window.location.href?.includes("shopkeeper-panel"))) {
    // sendWebsiteEventMessage('[LIVE] ' + lsDisplayInfo);
    socket.timeout(3000).emit("chat message", {
      chatUserId: "USER-54101",
      creationDateTime: new Date().toISOString(),
      contentType: "STRING",
      content: "LS17-" + JSON.stringify({
        "Action": "SEND_MESSAGE",
        "Content": "UD-STATE-" + JSON.stringify({
          ...rootState.livestreamState.senderObject,
          currentPage: window.location.href,
          timestamp: new Date().toISOString(),
          livestreamDisplayInfo: lsDisplayInfo ?? {}, // 'MINI-ACTIVE' or 'MINI-MUTED' or 'LIVE-ACTIVE' or 'OFF'
        }),
        "Sender": {
          "Attributes": rootState.livestreamState.senderObject,
        }
      }),
      author: "OTHER",
    });
  }
})



export const liveStreamState = createSlice({
  name: 'livestreamState',
  initialState,
  reducers: {
    setSenderObject: (state, action: PayloadAction<{
      userIdentifier?: string
      displayName?: string
      customerName?: string
    }>) => {
      if (action.payload.userIdentifier) {
        state.senderObject.userIdentifier = action.payload.userIdentifier;
      }
      if (action.payload.displayName) {
        state.senderObject.displayName = action.payload.displayName;
      }
      if (action.payload.customerName) {
        state.senderObject.customerName = action.payload.customerName;
      }
    },
    setStreamIsOn: (state, action: PayloadAction<boolean>) => {
      state.streamIsOn = action.payload;
      state.livestreamIntroDialogStatus = action.payload ? UIOverlayViewStatus.On : UIOverlayViewStatus.OffAndReady;
    },
    setLivestreamDialog: (state, action: PayloadAction<'MINI' | 'LIVE'>) => {
      state.liveStreamDialogState = action.payload;
      state.miniMuteStatus = 'ACTIVE';
    },
    setMiniMuteStatus: (state, action: PayloadAction<'MUTED' | 'ACTIVE'>) => {
      state.miniMuteStatus = action.payload;
    },
    closeLivestreamIntroDialog: (state) => {
      state.livestreamIntroDialogStatus = UIOverlayViewStatus.OffAndReady;

      // Open full screen when livestream intro dialog is closed
      state.liveStreamDialogState = 'MINI';
      state.miniMuteStatus = 'ACTIVE';
    },
    updateOfflineLiveState: (state, action: PayloadAction<any>) => {
      if (action.payload?.justUpdateSize) {
        state.offlineSharescreenState = {
          ...state.offlineSharescreenState,
          currentBodyMeasurements: action.payload.currentBodyMeasurements,
        }
      } else if (action.payload?.justUpdateRegularSizeValue) {
        state.offlineSharescreenState = {
          ...state.offlineSharescreenState,
          currentRegularSizeValue: action.payload.currentRegularSizeValue,
        }
      } else if (action.payload?.justUpdateCategoryTabIndex) {
        state.offlineSharescreenState = {
          ...state.offlineSharescreenState,
          categoryTabIndex: action.payload.categoryTabIndex,
        }
      } else if (action.payload?.justUpdateOfflineLivesaleProduct) {
        state.offlineSharescreenState = {
          ...state.offlineSharescreenState,
          livestreamProductId: action.payload.livestreamProductId,
          livestreamProductCount: action.payload.livestreamProductCount,
          livestreamProductPrice: action.payload.livestreamProductPrice,
          livestreamProductTimeLimit: action.payload.livestreamProductTimeLimit,
        }
      } else if (action.payload?.justUpdateGuidelines) {
        state.offlineSharescreenState = {
          ...state.offlineSharescreenState,
          guidelinesData: action.payload.guidelinesData,
        }
      } else {
        state.offlineSharescreenState = action.payload;
      }
    },
  },
  extraReducers(builder) {
  }
})

// Action creators are generated for each case reducer function
export const { setStreamIsOn, setLivestreamDialog, setMiniMuteStatus, closeLivestreamIntroDialog, setSenderObject, updateOfflineLiveState } = liveStreamState.actions

export default liveStreamState.reducer